import AllRecordedSessions from '../Components/AllRecordedSessions';
import CreateRecordedSession from '../Components/CreateRecordedSessions';

export const RecordedSessionRoutes = [
  {
    Component: AllRecordedSessions,
    path: "/all",
    exact: true,
    id: "dashboardRecordedSessionsAll",
    routePath: "/dashboard/recorded-sessions/all",
    name: "All Recorded Sessions"
  },
  {
    Component: CreateRecordedSession,
    path: '/edit/:id',
    exact: true,
    id: 'dashboardRecordedSessionsEdit',
  },
  {
    Component: CreateRecordedSession,
    path: "/create",
    exact: true,
    id: "dashboardRecordedSessionsCreate",
    routePath: "/dashboard/recorded-sessions/create",
    name: "Create Recorded Session"
  }
];
